const InstagramIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      fill="none"
      viewBox="0 0 46 46"
      className={className}
    >
      <g clipPath="url(#clip0_741_5958)">
        <path
          fill="currentColor"
          d="M23.004 18.35c-2.612 0-4.719 2.074-4.719 4.646 0 2.571 2.107 4.645 4.72 4.645 2.611 0 4.718-2.074 4.718-4.645 0-2.572-2.107-4.646-4.719-4.646zm0 7.666c-1.688 0-3.068-1.354-3.068-3.02s1.376-3.02 3.068-3.02c1.692 0 3.068 1.354 3.068 3.02s-1.38 3.02-3.068 3.02zm6.013-7.856a1.09 1.09 0 01-1.1 1.084 1.09 1.09 0 01-1.102-1.084c0-.598.493-1.083 1.101-1.083s1.1.485 1.1 1.083zm3.125 1.1c-.07-1.451-.406-2.737-1.486-3.796-1.076-1.06-2.383-1.391-3.857-1.464-1.52-.085-6.074-.085-7.594 0-1.47.069-2.776.4-3.857 1.46-1.08 1.059-1.413 2.345-1.486 3.796-.087 1.496-.087 5.98 0 7.476.07 1.45.406 2.737 1.486 3.796 1.08 1.06 2.382 1.39 3.857 1.463 1.52.085 6.074.085 7.594 0 1.474-.068 2.78-.4 3.857-1.463 1.076-1.06 1.413-2.345 1.486-3.796.087-1.496.087-5.976 0-7.472zm-1.963 9.077a3.082 3.082 0 01-1.75 1.722c-1.211.473-4.086.364-5.425.364-1.339 0-4.218.105-5.426-.364a3.082 3.082 0 01-1.75-1.722c-.48-1.193-.369-4.023-.369-5.341 0-1.318-.107-4.152.37-5.341.32-.792.94-1.403 1.75-1.722 1.211-.473 4.086-.364 5.425-.364 1.339 0 4.218-.105 5.426.364a3.082 3.082 0 011.75 1.722c.48 1.193.369 4.023.369 5.34 0 1.319.11 4.153-.37 5.342z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_741_5958">
          <path
            fill="#fff"
            d="M0 0H18.4V20.7H0z"
            transform="translate(13.8 12.65)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export default InstagramIcon;
